import React from 'react';
import { Route, IndexRedirect } from "react-router";
import { checkRolePermission } from '../../libs/checkPermission';

import HydrologyRatingTableList from './RT Method/Table/NewList';
import HydrologyRatingTableAdd from './RT Method/Table/TableAdd';
import HydrologyRatingTableModify from './RT Method/Table/TableEdit';
import HydrologyRatingTables from './RT Method/RatingTables';
import HydrologyVerificationTool from './RT Method/VerificationTool';
import HydrologyIndexVelocityMethod from './IndexVelocityMethod';

import RTEquationList from './RTEquations/RTEquationList';
import RTEquationsDerive from './RTEquations/RTEquationsDerive';
import RatingEquationModify from './RTEquations/RatingEquationModify';
import RatingCurveEquationModify from './RTEquations/RatingCurveEquationModify';
import { inject, observer } from 'mobx-react';
import Spinner from '../Spinner';
import TabBar from '../TabBar';

@inject("ratingEquationStore", "folderStore", 'stationStore', 'parameterStore')
@observer
class RTEquationWrapper extends React.Component {
  componentWillMount() {
    const { ratingEquationStore, parameterStore } = this.props;
    ratingEquationStore.fetchItems();
    parameterStore.fetchItems();
  }
  render() {
    const { ratingEquationStore, folderStore, stationStore, children } = this.props;
    if (ratingEquationStore.isLoading || folderStore.isLoading || stationStore.isLoading) return <Spinner />;
    else return children;
  }
}

const Home = props => {
  return (
    <div className='inner-section-root'>
      <TabBar
        items={[
          // { to: '/hydrology/rt_method', label: 'RT Method' },
          { to: '/hydrology/rt_equations', label: 'RT Equations' },
          // { to: '/hydrology/index_velocity_method', label: 'Index Velocity Method' },
        ]}
      />
      <div className='inner-section-content'>
        {props.children}
      </div>
    </div>
  );
};


export const HydrologyRoutes = () => (
  <Route component={Home}>
    <IndexRedirect to="rt_equations" />
    <Route path="rt_method">
      <IndexRedirect to="table_list" />
      <Route path="table_list" component={HydrologyRatingTableList} name="view hydrology-table-list">
        <Route path="add" component={checkRolePermission(HydrologyRatingTableAdd)} name="modify hydrology-table-list" />
        <Route path=":id" component={checkRolePermission(HydrologyRatingTableModify)} name="modify hydrology-table-list" />
      </Route>
      <Route path="rating_tables" component={HydrologyRatingTables} />
      <Route path="verification_tool" component={HydrologyVerificationTool} />
    </Route>
    <Route path="rt_equations" component={RTEquationWrapper}>
      <IndexRedirect to='list' />
      <Route path='list' component={RTEquationList}>
        <Route path=":id" component={RatingEquationModify} />
      </Route>
      <Route path=':id/equation/:eq_id' component={RatingCurveEquationModify} />
      <Route path='derive' component={RTEquationsDerive} />
    </Route>
    <Route path="index_velocity_method" component={HydrologyIndexVelocityMethod} />
  </Route>
)


// WEBPACK FOOTER //
// ./src/components/Hydrology/routes.js